export enum StateParamValues {
  INFO = 'info',
}

export const BILLING_PAGE_PATH = '/billing/:state';
export const BILLING_PAGE_PATH_ALIAS = '/billing/info';
